import styled from '@emotion/styled';

import { FormInput as BaseFormInput } from '../FormInput';

export const FormInput = styled(BaseFormInput)`
  margin-bottom: 0px;
  margin-top: 0px;
  .MuiInputBase-root {
    border-radius: 5px;
    background: #e6e6e6 0% 0% no-repeat padding-box;
    border: 1px solid #e6e6e6;
    border-radius: 5px;
    height: 48px;
  }
  .MuiFilledInput-underline:before {
    border: none;
  }

  .MuiFormLabel-root:not(.Mui-error) {
    color: #b3b3b3;
    font-size: 16px;
    letter-spacing: 0px;
  }

  .MuiInputBase-input {
    padding-bottom: 8px;
    padding-top: 21px;
    &:-webkit-autofill {
      border-top-left-radius: inherit;
      border-top-right-radius: inherit;
      border-bottom-right-radius: inherit;
      border-bottom-left-radius: inherit;
    }
  }
  .MuiInputLabel-filled.MuiInputLabel-shrink {
    transform: translate(12px, 6px) scale(0.75);
  }
  .MuiFormHelperText-root {
    margin-right: 0px;
    margin-left: 0px;
  }
`;
